import './HeroContentImgStyles.css';

import React, { Component } from 'react'

class HeroContentImg extends Component {
  render() {
    return (
      <div className='heroContentImg'>
        <div className='heading'>
          <h1>{this.props.heading}</h1>
          <p>{this.props.text}</p>
        </div>
      </div>
    )
  }
}

export default HeroContentImg
